import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/messaging/campaigns/')({
  beforeLoad: () => {
    throw redirect({ to: '/correo/campaigns' });
  },
});
